/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from "@material-ui/core/DialogContentText";
import {useQuery} from "@apollo/react-hooks";
import {GET_MY_RESOURCES} from "../database/queries/userQueries";
import {GET_ACCOUNT, GET_ACCOUNTS_BY_NAME} from "../database/queries/accountQueries";
import {GET_CONTACT, GET_CONTACTS_NAMES} from "../database/queries/contactQueries";
import {GET_PROJECT, GET_PROJECTS_BY_NAME} from "../database/queries/projectQueries";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import {Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import {makeStyles} from "@material-ui/core/styles";
import {notify} from "../utils/notify";

const useStyles = makeStyles(theme => ({
    dialog: {
        '& .MuiDialog-paper': {
            width: 600,
        },
    },
    formControl: {
        marginTop: 0,
        marginBottom: 0,
        'input': {
            '&::placeholder': {
                color: 'blue'
            }
        },
        '& .MuiFormLabel-root': {
            color: '#a0aec0'
        },
        '& .MuiAutocomplete-inputRoot': {
            paddingBottom: 0,
        }
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    rightField: {
        paddingLeft: 10,
    },
}));

const INITIAL_DIALOG = {type: 'general', id: 'general', name: ''};

const ChooseTargetDialog = props => {
    const classes = useStyles();
    const [target, setTarget] = useState(INITIAL_DIALOG);
    const [autocompleteFilter, setAutocompleteFilter] = useState('');
    const [autocompleteOptions, setAutocompleteOptions] = useState([]);
    const [autocompleteOpen, setAutocompleteOpen] = React.useState(false);
    const [resources, setResources] = useState();

    const {error: getUserResourcesError, data: getUserResourcesData} = useQuery(GET_MY_RESOURCES, {
        skip: resources
    });

    const {error: getAccountError, data: getAccountData, refetch: getAccountRefetch} = useQuery(GET_ACCOUNT, {
        skip: target.type !== 'account' || !target.id,
        variables: {accountId: target.id},
    });

    const {loading: getAccountsByNameLoading, error: getAccountsByNameError, refetch: getAccountsByNameRefetch} = useQuery(GET_ACCOUNTS_BY_NAME, {
        skip: target.type !== 'account',
        variables: {searchStr: autocompleteFilter, limit: 5, orderList: ['accountName ASC']},
    });

    const {error: getContactError, data: getContactData, refetch: getContactRefetch} = useQuery(GET_CONTACT, {
        skip: target.type !== 'contact' || !target.id,
        variables: {contactId: target.id},
    });

    const {loading: getcontactsNamesLoading, error: getcontactsNamesError, refetch: getcontactsNamesRefetch} = useQuery(GET_CONTACTS_NAMES, {
        skip: target.type !== 'contact',
        variables: {
            searchStr: autocompleteFilter,
            limit: 5,
            orderList: ['contactLastName ASC', 'contactFirstName ASC']
        },
    });

    const {error: getProjectError, data: getProjectData, refetch: getProjectRefetch} = useQuery(GET_PROJECT, {
        skip: target.type !== 'project' || !target.id,
        variables: {projectId: target.id},
    });

    const {loading: getProjectsByNameLoading, error: getProjectsByNameError, refetch: getProjectsByNameRefetch} = useQuery(GET_PROJECTS_BY_NAME, {
        skip: target.type !== 'project',
        variables: {searchStr: autocompleteFilter, limit: 5, orderList: ['projectName ASC']},
    });

    useEffect(() => {
        if (getUserResourcesError) notify('getUserResourcesError', 'error', getUserResourcesError.message);
        if (getAccountError) notify('getAccountError', 'error', getAccountError.message);
        if (getAccountsByNameError) notify('getAccountsByNameError', 'error', getAccountsByNameError.message);
        if (getContactError) notify('getContactError', 'error', getContactError.message);
        if (getcontactsNamesError) notify('getcontactsNamesError', 'error', getcontactsNamesError.message);
        if (getProjectError) notify('getProjectError', 'error', getProjectError.message);
        if (getProjectsByNameError) notify('getProjectsByNameError', 'error', getProjectsByNameError.message);
    }, [getUserResourcesError, getAccountError, getAccountsByNameError, getContactError, getcontactsNamesError, getProjectError, getProjectsByNameError]);

    useEffect(() => {
        if (getUserResourcesData) {
            setResources(getUserResourcesData.userResources);
        }
    }, [getUserResourcesData]);

    useEffect(() => {
        if (autocompleteFilter && autocompleteFilter.length > 0) {
            if (target.type === 'account') {
                getAccountsByNameRefetch()
                    .then((result) => {
                        let myAccounts = [];
                        if (result.data && result.data.accountsByName) {
                            result.data.accountsByName.map(account => myAccounts.push({
                                    id: account.accountId,
                                    name: account.displayName
                                })
                            );
                        }
                        setAutocompleteOptions(myAccounts);
                    })
                    .catch(e => {
                        console.trace(e);
                    });
            } else if (target.type === 'contact') {
                getcontactsNamesRefetch()
                    .then((result) => {
                        let myContacts = [];
                        if (result.data && result.data.contactsNames) {
                            result.data.contactsNames.map(contact => myContacts.push({
                                    id: contact.contactId,
                                    name: contact.displayName
                                })
                            );
                        }
                        setAutocompleteOptions(myContacts);
                    })
                    .catch(e => {
                        console.trace(e);
                    });
            } else if (target.type === 'project') {
                getProjectsByNameRefetch()
                    .then((result) => {
                        let myProjects = [];
                        if (result.data && result.data.projectsByName) {
                            result.data.projectsByName.map(project => myProjects.push({
                                    id: project.projectId,
                                    name: project.projectName
                                })
                            );
                        }
                        setAutocompleteOptions(myProjects);
                    })
                    .catch(e => {
                        console.trace(e);
                    });
            }
        }
    }, [autocompleteFilter, getAccountsByNameRefetch, getcontactsNamesRefetch, getProjectsByNameRefetch, target.type]);

    useEffect(() => {
        if (getAccountData && getAccountData.account) {
            const theAccount = {
                type: 'account',
                id: getAccountData.account.accountId,
                name: getAccountData.account.displayName
            };
            setTarget(theAccount);
            setAutocompleteOptions([theAccount]);
        }
    }, [getAccountData]);

    useEffect(() => {
        if (getContactData && getContactData.contact) {
            const theContact = {
                type: 'contact',
                id: getContactData.contact.contactId,
                name: getContactData.contact.displayName
            };
            setTarget(theContact);
            setAutocompleteOptions([theContact]);
        }
    }, [getContactData]);

    useEffect(() => {
        if (getProjectData && getProjectData.project) {
            const theProject = {
                type: 'project',
                id: getProjectData.project.projectId,
                name: getProjectData.project.projectName
            };
            setTarget(theProject);
            setAutocompleteOptions([theProject]);
        }
    }, [getProjectData]);

    useEffect(() => {
        if (!autocompleteOpen) {
            setAutocompleteOptions([]);
        }
    }, [autocompleteOpen]);

    useEffect(() => {
        if (target.type === 'account' && target.id) getAccountRefetch();
        if (target.type === 'contact' && target.id) getContactRefetch();
        if (target.type === 'project' && target.id) getProjectRefetch();
    }, [getAccountRefetch, getContactRefetch, getProjectRefetch, target]);

    useEffect(() => {
        setTarget({
            type: props.parentType ? props.parentType : 'general',
            id: props.parentId ? props.parentId : 'general',
            name: '',
        });
    }, [props.parentId, props.parentType]);

    return (
        <Dialog
            open={props.open}
            onClose={props.handleNo}
            className={classes.dialog}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.question}
                </DialogContentText>
                {target && target.type && resources && (
                    <Grid container>
                        <Grid item xs={6} className={classes.middleField}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <InputLabel id="label-target-target-type" required>
                                    Target type
                                </InputLabel>
                                <Select
                                    required
                                    id="parentType"
                                    name="parentType"
                                    labelid="label-target-target-type"
                                    fullWidth
                                    size="small"
                                    value={target.type}
                                    onChange={(e) => {
                                        if (e.target && e.target.value !== target.type) {
                                            setTarget({
                                                type: e.target.value,
                                                id: null,
                                                name: null
                                            });
                                        }
                                    }}
                                >
                                    <MenuItem value="general">General</MenuItem>
                                    {resources.accounts && resources.accounts > 0 &&
                                    <MenuItem value="account">Account</MenuItem>
                                    }
                                    {resources.contacts && resources.contacts > 0 &&
                                    <MenuItem value="contact">Contact</MenuItem>
                                    }
                                    {resources.projects && resources.projects > 0 &&
                                    <MenuItem value="project">Project</MenuItem>
                                    }
                                    {resources.tasks && resources.tasks > 0 &&
                                    <MenuItem value="task">Task</MenuItem>
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        {target.type !== 'general' && (
                            <Grid item xs={6} className={classes.rightField}>
                                <FormControl
                                    className={classes.formControl}
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                >
                                    <Autocomplete
                                        required
                                        style={{width: '100%'}}
                                        open={autocompleteOpen}
                                        onOpen={() => {
                                            setAutocompleteOpen(true);
                                        }}
                                        onClose={() => {
                                            setAutocompleteOpen(false);
                                        }}
                                        onInputChange={(event, value, reason) => {
                                            setAutocompleteFilter(value);
                                        }}
                                        getOptionSelected={(option, value) => {
                                            return option.id === value.id
                                        }}
                                        getOptionLabel={option => {
                                            return option.name ? option.name : ''
                                        }}
                                        onChange={(event, value) => {
                                            setTarget({
                                                ...target,
                                                id: value.id,
                                                name: value.name
                                            });
                                        }}
                                        options={autocompleteOptions}
                                        loading={getAccountsByNameLoading || getcontactsNamesLoading || getProjectsByNameLoading}
                                        value={target}
                                        renderInput={params => {
                                            return (
                                                <TextField
                                                    {...params}
                                                    label="Target"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {getAccountsByNameLoading || getcontactsNamesLoading || getProjectsByNameLoading ?
                                                                    <CircularProgress color="inherit"
                                                                                      size={20}/> : null}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        )}
                    </Grid>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    id={"confirmation-no"}
                    variant="contained"
                    onClick={() => {
                        setTarget({
                            type: props.parentType ? props.parentType : 'general',
                            id: props.parentId ? props.parentId : 'general',
                            name: '',
                        });
                        props.handleNo();
                    }}
                    color="secondary"
                >
                    Cancel
                </Button>
                <Button
                    id={"confirmation-yes"}
                    variant="contained"
                    onClick={() => {
                        props.handleYes({...target});
                    }}
                    color="primary"
                    autoFocus
                    disabled={target.type !== 'general' && !target.id}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChooseTargetDialog
